import Swiper, { Navigation } from "swiper";
import InitProductForms from "../../core/components/init-product-forms";
import InitAddToCartButtons from "../../core/components/init-add-to-cart-buttons";
import QuantityComponents from "../../core/components/quantity-components";

const ProductSlider = function () {

    Swiper.use([Navigation]);

    const sections = document.querySelectorAll( '.product-slider' );

    const initProductSwiper = (section) => {
        const swiperEl = section.querySelector( '.product-swiper' );
        const prevEl = section.querySelector( '.swiper-button-prev' );
        const nextEl = section.querySelector( '.swiper-button-next' );

        const swiper = new Swiper(swiperEl, {
            slidesPerView: 1.1,
            spaceBetween: 8,
            watchOverflow: true,
            navigation: {
                nextEl,
                prevEl
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.1,
                    spaceBetween: 8,
                },
                992: {
                    slidesPerView: 3.3,
                    spaceBetween: 32,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
            }
        })
    }

    for (const section of sections) {

        const tabContainers = section.querySelectorAll( '[data-tab-content]' );

        const tabs = section.querySelectorAll( '[data-tab]' );
        tabs.forEach( function( tab ){
            tab.addEventListener( 'click', function( e ){
                e.preventDefault();
                tabs.forEach( function( tab ){
                    tab.classList.remove( 'active' );
                });
                tab.classList.add( 'active' );
                const target = tab.dataset.tab;
                tabContainers.forEach( function( tabContainer ){
                    tabContainer.classList.remove( 'active' );
                    if( tabContainer.dataset.tabContent === target ){
                        tabContainer.classList.add( 'active' );
                    }
                });
            });
        });

        if (tabs.length > 1) {
            const tabSwiperEl = section.querySelector( '.tab-swiper' );
            const tabSwiper = new Swiper(tabSwiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                watchOverflow: true,
                breakpoints: {
                    576: {
                        spaceBetween: 32,
                    }
                }
            })
        }

        if (section.classList.contains('product-recommendations')) {
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
            
                observer.unobserve(section);
            
                const url = section.dataset.url;
            
                fetch(url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('.product-recommendations');
            
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        section.innerHTML = recommendations.innerHTML;
                    }
                    
                    initProductSwiper(section);

                    InitProductForms('.product-recommendations [sh-product-form]');
                    InitAddToCartButtons('.product-recommendations [sh-add-to-cart]');
                    QuantityComponents('.product-recommendations [sh-quantity-component]');
                }).catch(e => {
                    console.error(e);
                });
            };
            
            const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
            
            observer.observe(section);
        } else {
            tabContainers.forEach( function( tabContainer ){
                initProductSwiper(tabContainer);
            });
        }

    }

}
  
export default ProductSlider